type Permission = { feature: string; permissionMask: number };
type MenuItem = {
  id?: string;
  label?: string;
  link?: string;
  icon?: any;
  isTitle?: boolean;
  permissionFeature?: string;
  permissionFeatures?: string[];
  mobileOnly?: boolean;
  subItems?: MenuItem[];
  [k: string]: any;
};

export function filterMenuByPermissions(
  permissions: Permission[] | undefined,
  menuData: MenuItem[] | undefined,
): MenuItem[] {
  const map: Record<string, number> = {};
  (permissions || []).forEach((p) => {
    if (p && p.feature) map[p.feature] = Number(p.permissionMask) || 0;
  });
  const isAllowed = (feature?: string) => {
    if (!feature) return true;
    return !!(map[feature] && map[feature] > 0);
  };

  const isAllowedByAnyFeature = (features?: string[]) => {
    if (!features?.length) return true;
    return features.some((feature) => isAllowed(feature));
  };

  const filterItem = (item: MenuItem): MenuItem | null => {
    if (!item) return null;
    if (item.permissionFeature && !isAllowed(item.permissionFeature)) return null;
    if (item.permissionFeatures && !isAllowedByAnyFeature(item.permissionFeatures)) return null;

    if (Array.isArray(item.subItems)) {
      const subs = item.subItems.map(filterItem).filter((s): s is MenuItem => s !== null);
      if (subs.length === 0) return null;
      return { ...item, subItems: subs };
    }

    return { ...item };
  };

  const out: MenuItem[] = [];
  if (!Array.isArray(menuData)) return out;

  for (let i = 0; i < menuData.length; i++) {
    const item = menuData[i];
    if (item?.isTitle) {
      const group: MenuItem[] = [];
      let j = i + 1;
      while (j < menuData.length && !menuData[j]?.isTitle) {
        const keep = filterItem(menuData[j]);
        if (keep) group.push(keep);
        j++;
      }
      if (group.length > 0) {
        out.push({ ...item });
        out.push(...group);
      }
      i = j - 1;
    } else {
      const keep = filterItem(item);
      if (keep) out.push(keep);
    }
  }

  return out;
}
